/* AcheterLush — scripts des sections « lr-* » */
(function () {
  'use strict';

  function money(cents) {
    var fmt = window.lrMoneyFormat || '${{amount}}';
    var n = (cents / 100).toFixed(2);
    if (/comma_separator/.test(fmt)) n = n.replace('.', ',');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, n);
  }

  /* Compte à rebours (jusqu'à minuit, heure locale) ------------------------ */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    function tick() {
      var now = new Date();
      var end = new Date(now); end.setHours(24, 0, 0, 0);
      var d = Math.max(0, Math.floor((end - now) / 1000));
      h.textContent = String(Math.floor(d / 3600)).padStart(2, '0');
      m.textContent = String(Math.floor(d % 3600 / 60)).padStart(2, '0');
      s.textContent = String(d % 60).padStart(2, '0');
    }
    tick(); setInterval(tick, 1000);
  });

  /* Galerie ---------------------------------------------------------------- */
  document.querySelectorAll('[data-lr-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('[data-slide]');
    var thumbs = g.querySelectorAll('[data-thumb]');
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (el, k) { el.hidden = k !== i; });
      thumbs.forEach(function (el, k) { el.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = g.querySelector('[data-prev]'), next = g.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
  });

  /* Sélecteur d'ensembles -------------------------------------------------- */
  document.querySelectorAll('[data-lr-pdp]').forEach(function (pdp) {
    var list = pdp.querySelector('[data-bundles]');
    if (!list) return;
    function apply(input) {
      list.querySelectorAll('[data-bundle]').forEach(function (card) {
        card.classList.toggle('is-selected', card.querySelector('input') === input);
      });
      var price = parseInt(input.getAttribute('data-price'), 10);
      var compare = parseInt(input.getAttribute('data-compare') || '0', 10);
      pdp.querySelectorAll('[data-atc-price]').forEach(function (el) { el.textContent = money(price); });
      pdp.querySelectorAll('[data-atc-compare]').forEach(function (el) {
        el.textContent = compare > price ? money(compare) : '';
      });
      var btn = pdp.querySelector('[data-atc]');
      if (btn) btn.disabled = input.getAttribute('data-available') !== 'true';
    }
    list.addEventListener('change', function (e) { if (e.target.matches('input[type="radio"]')) apply(e.target); });
    var checked = list.querySelector('input:checked');
    if (checked) apply(checked);

    var sticky = document.querySelector('[data-lr-sticky]');
    var atc = pdp.querySelector('[data-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0; });
      }).observe(atc);
    }
  });

  /* Fenêtres modales ------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-modal-open]');
    if (open) {
      var m = document.getElementById(open.getAttribute('data-modal-open'));
      if (m) { m.hidden = false; document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.matches('[data-modal-close]') || e.target.classList.contains('lr-modal')) {
      var modal = e.target.closest('.lr-modal');
      if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.lr-modal').forEach(function (m) { m.hidden = true; document.body.style.overflow = ''; });
  });

  /* Carrousels + FAQ ------------------------------------------------------- */
  document.querySelectorAll('[data-lr-carousel]').forEach(function (c) {
    var track = c.querySelector('[data-track]');
    function step() { var f = track.children[0]; return f ? f.getBoundingClientRect().width + 20 : 320; }
    var p = c.querySelector('[data-prev]'), n = c.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
  document.querySelectorAll('[data-faq-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var faq = btn.closest('.lr-faq');
      var on = faq.classList.toggle('is-expanded');
      btn.textContent = on ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    });
  });
})();
